/**
 * Created by weballan on 2020/06/08.
 *
 * 全局化过滤器
 * 您还可以在组件定义时的 filters 属性中按需引入
 */
import Vue from 'vue'
import formatAccount from './formatAccount'

Vue.filter('formatAccount',formatAccount)



// WEBPACK FOOTER //
// ./src/prestamate/filters/index.js